module.exports = __webpack_public_path__ + "img/bmsOPENCARD_SMALL.f6e88884.jpg";